import React from 'react';
import { Sparkles } from 'lucide-react';

interface DraftRestoreBannerProps {
  onResetDraft: () => void;
}

export const DraftRestoreBanner: React.FC<DraftRestoreBannerProps> = ({ onResetDraft }) => {
  return (
    <div className="p-3.5 rounded-xl bg-amber-50 border border-amber-200/80 text-amber-900 text-xs flex items-center justify-between gap-3 animate-in fade-in slide-in-from-top-2 duration-200">
      <div className="flex items-center gap-2 min-w-0">
        <Sparkles className="w-4 h-4 text-amber-600 shrink-0" />
        <span className="truncate">
          <strong className="font-bold text-amber-800">Draf Pemulihan Otomatis:</strong> Sesi
          pengisian sebelumnya berhasil dipulihkan.
        </span>
      </div>
      <button
        type="button"
        onClick={onResetDraft}
        className="px-2.5 py-1 bg-white hover:bg-amber-100 border border-amber-300 rounded-lg text-[10px] font-bold text-amber-800 transition shrink-0 cursor-pointer shadow-3xs"
      >
        Reset Draf
      </button>
    </div>
  );
};
